import { Component, OnInit } from '@angular/core';
import { InactivityService } from './shared/auth/inactivity.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  // title = 'preclinic-angular';
  constructor(
    private inactivityService: InactivityService
  ) { }

  ngOnInit(): void {
    // activo el bloqueo automático por inactividad
    this.inactivityService.iniciarControlInactividad();
  }
}
